const es = {
    header: {
        title: 'Notificaciones',
        'mark-all-read': 'Marcar todo como leído',
    },
    notification: {
        'mark-as-read': 'Marcar como leído',
        'mark-as-unread': 'Marcar como no leído',
        delete: 'Eliminar',
        menu: 'Menu',
    },
    'web-push-notifications': {
        notice: 'Active notificaciones en su navegador para mantenerse actualizado',
        'enable-now': 'Activar',
    },
    messages: {
        'empty-inbox': '¡No tiene notificaciones!<br>Le haremos saber cuando llegue una.',
    },
    preferences: {
        title: 'Preferencias',
        toggle: 'Preferencias de notificación',
        close: 'Cerrar preferencias',
    },
};
export default es;
//# sourceMappingURL=es.js.map